module.exports = __webpack_public_path__ + "img/img_035@2x.434da8a6.png";